module.exports = __webpack_public_path__ + "img/19.56168f22.png";